import React from 'react'

import { Skeleton } from '@mui/material'
import { useCustomer } from 'features/customers/hooks/useCustomer'

type RevealUsageCustomerProps = {
  customerId: number
}

const RevealUsageCustomer = ({ customerId }: RevealUsageCustomerProps) => {
  const { data, isLoading } = useCustomer(customerId)

  return isLoading ? <Skeleton height={15} width={200} /> : data?.name
}

export default RevealUsageCustomer
